<template>
  <v-dialog :value="value" max-width="480" persistent>
    <v-card>
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>

      <v-card-text class="pb-4">
        <div v-for="(line, index) in messageLines" :key="index">
          {{ line }}
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="$emit('confirm')">
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'แจ้งเตือน'
    },
    message: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: 'ตกลง'
    }
  },
  computed: {
    messageLines() {
      return (this.message || '').split('\n')
    }
  }
}
</script>
